<template>
  <aside class="cards-summary">
    <div class="card total">
      <h3>Total Recebido</h3>
      <p>{{ total }}</p>
    </div>
    <div class="card chatbot">
      <h3>Chatbot</h3>
      <p>{{ chatbot }}</p>
    </div>
    <div class="card aguardando">
      <h3>Aguardando</h3>
      <p>{{ aguardando }}</p>
    </div>
    <div class="card em-atendimento">
      <h3>Em atendimento</h3>
      <p>{{ emAtendimento }}</p>
    </div>
  </aside>
</template>

<script>
import socket from './../../../modules/realtime/service/service';

export default {
  name: "RealtimeAttendancesCount",
  props: ['total', 'chatbot', 'aguardando', 'emAtendimento', 'userChatQueues'],
};
</script>

<style>
.cards-summary {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.cards-summary .card {
  flex: 1;
  border-radius: 8px;
  padding: 1rem;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.cards-summary .card h3 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
}

.cards-summary .card p {
  font-size: 1.4rem;
  font-weight: bold;
}

.cards-summary .card.total {
  background: #0d3b66;
}

.cards-summary .card.chatbot {
  background: #9da8b2; 
}

.cards-summary .card.aguardando {
  background: #be1724; 
  color: #333; 
}

.cards-summary .card.em-atendimento {
  background: #2e7d32;
}
</style>
